import { Grid, MenuItem } from '@mui/material';
import { IProcessManager } from '../../Interfaces/IProcessManager';
import {
  IProcessManagerAutomation,
  IProcessManagerAutomationLegalRequirementChange,
  processManagerAutomationLegalRequirementChangeSchema,
} from '../../Interfaces/IProcessManagerAutomation';
import { ILegalPhaseFullObject } from '../../Interfaces/ILegalPhase';
import { CustomeTextField } from '../../generic/CustomeTextField';
import { ILegalRequirementState } from '../../Interfaces/ILegalRequirementState';
import { useEffect } from 'react';
import { SelectRequirement } from '../../LegalTransaction/LegalPhase/SelectRequirement';

interface IProps {
  processManager: IProcessManager;
  editAutomation: IProcessManagerAutomation;
  setEditAutomation: Function;
  //
  legalPhases: ILegalPhaseFullObject[];
  legalReqStates: ILegalRequirementState[];
  //
  setIsValidatedChild: Function;
}

function isLegalRequirementChange(
  data: IProcessManagerAutomation['data']
): data is IProcessManagerAutomationLegalRequirementChange {
  return processManagerAutomationLegalRequirementChangeSchema.safeParse(data)
    .success;
}

export const EditPMAutomationRequirement: React.FC<IProps> = ({
  processManager,
  editAutomation,
  setEditAutomation,
  legalPhases,
  legalReqStates,
  setIsValidatedChild,
}) => {
  useEffect(() => {
    if (isLegalRequirementChange(editAutomation.data)) {
      setIsValidatedChild(editAutomation.data.idLegalRequirement > 0);
    }
  }, [editAutomation.data]);

  if (!isLegalRequirementChange(editAutomation.data)) {
    return <>Fehler: Ungültige Datenstruktur!</>;
  }

  return (
    <>
      <Grid item sm={8}>
        <SelectRequirement
          idLegalRequirement={
            editAutomation.data.idLegalRequirement === -1
              ? null
              : editAutomation.data.idLegalRequirement
          }
          setIdLegalRequirement={(updatedId: number) => {
            setEditAutomation({
              ...editAutomation,
              data: {
                ...editAutomation.data,
                idLegalRequirement: updatedId,
              },
            });
          }}
          legalPhases={legalPhases}
        />
      </Grid>
      <Grid item sm={4}>
        <CustomeTextField
          label='Status setzen auf'
          attr='idLegalRequirementState'
          object={editAutomation.data}
          setObject={(
            updatedData: IProcessManagerAutomationLegalRequirementChange
          ) => {
            setEditAutomation({ ...editAutomation, data: updatedData });
          }}
          type='select'
        >
          {legalReqStates.map(state => (
            <MenuItem
              key={`select-pm-requirementstate-${state.idLegalRequirementState}`}
              value={state.idLegalRequirementState}
            >
              {state.LegalRequirementState}
            </MenuItem>
          ))}
        </CustomeTextField>
      </Grid>
    </>
  );
};
